import React from 'react';

import { Checkbox, FormControl } from '@chakra-ui/react';
import { useField } from 'formik';

import { FormikCheckBoxProps } from './FormikCheckBox.props';

const FormikCheckBoxView = (props: FormikCheckBoxProps): JSX.Element => {
  const [{ value }, , field] = useField(props.field);

  return (
    <FormControl>
      <Checkbox
        colorScheme="primary"
        value={props.name}
        isChecked={value}
        onChange={() => {
          if (!value) {
            field.setValue(true);
          } else {
            field.setValue(false);
          }
        }}
        {...props}>
        {props.name}
      </Checkbox>
    </FormControl>
  );
};

export default FormikCheckBoxView;
